import React from "react";
import { Text, Flex } from "@jsq/ds/core";
import { Icon, type IconType } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import * as styles from "./styles_vanilla.css";

export interface EmptyStateCardProps {
  /** Icon shown above the title (e.g. "comment", "file-alt"). */
  icon: IconType;
  title: string;
  subtitle?: string;
  iconVariant?: "solid" | "outline";
  "data-testid"?: string;
}

export const EmptyStateCard: React.FC<EmptyStateCardProps> = ({
  icon,
  title,
  subtitle,
  iconVariant = "outline",
  "data-testid": dataTestId,
}) => (
  <Flex
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    className={styles.card}
    data-testid={dataTestId}
  >
    <span className={styles.iconWrapper}>
      <Icon type={icon} variant={iconVariant} color={Colors.Neutral400} size="large" />
    </span>
    <Text variant="strong-md" color={Colors.Neutral900}>
      {title}
    </Text>
    {subtitle && (
      <Text variant="regular-md" color={Colors.Neutral600}>
        {subtitle}
      </Text>
    )}
  </Flex>
);

export default EmptyStateCard;
